import { useEffect } from 'react';

/**
 * Sets the document.title with FinTrack branding suffix.
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/title
 */
export function useDocumentTitle(title: string) {
  useEffect(() => {
    const prev = document.title;
    document.title = title ? `${title} | FinTrack` : 'FinTrack';
    return () => { document.title = prev; };
  }, [title]);
}
